import { HttpRequest } from '@angular/common/http'

export const authorizationRequest = (request: HttpRequest<unknown>, accessToken: string) => {
  return request.clone({ setHeaders: { Authorization: `Bearer ${accessToken}` } })
}
